declare const jQuery: any;
const $ = jQuery;

import { throttle } from "lodash";

const onSmallScreen: Function = window["iw"].breakpoints.onSmallScreen;
const findMaxHeightOfHidden: Function = window["iw"].layout.findMaxHeightOfHidden;

export function initGradientContent(): void
{
	$(".gradient-content.has-slides").each(function () {
		initWrap($(this));
	});
}

function initWrap($wrap): void
{
	const $outer = $wrap.find(".text-slides");
	const $inner = $wrap.find(".text-slides-inner");
	const $slides = $inner.children(".text-slide");
	setupLayoutFix($outer, $inner, $slides);
	setupNav($wrap, $outer, $inner, $slides);
}

function setupNav($wrap, $outer, $inner, $slides): void
{
	const $dots = $wrap.find("[data-dot-index]");
	let currIndex = 0;
	const selectCurrDot = () => {
		$dots.removeClass("selected").filter(`[data-dot-index="${currIndex}"]`).addClass("selected");
	};
	const slideTo = (index: number) => {
		if (!onSmallScreen())
		{
			if (currIndex === index)
			{
				return;
			}
			
			const transform = `translateX(${(index * -100)}%)`;
			$inner.css({ transform });
			currIndex = index;
		}
		else
		{
			$inner.css({ transform: "" });
			currIndex = 0;
		}
		selectCurrDot();
	};
	$dots.click(function (ev) {
		const $dot = $(this);
		if ($dot.is(".selected"))
		{
			return false;
		}
		const index: number = parseInt($dot.attr("data-dot-index"), 10);
		slideTo(index);
		return false;
	});
}

function setupLayoutFix($outer, $inner, $slides): void
{
	const reset = () => {
		$slides.removeClass("ready");
		$outer.add($slides).css({ height: "", position: "", display: "", left: "", opacity: "" });
		$inner.css({ transform: "" });
	};
	const fix = () => {
		reset();
		if (onSmallScreen())
		{
			return;
		}

		$slides.addClass("ready");

		// Slide/wrap height
		const h: number = findMaxHeightOfHidden($slides, true);
		$outer.add($slides).css({ height: h });

		// Slide position
		$slides.each(function (index: number) {
			$(this).css({ left: (index * 100) + "%" });
		});
	};
	
	fix();
	$(fix);
	$(window).on("load resize", throttle(fix, 100, { leading: true }));
}
